module.exports = __webpack_public_path__ + "img/hellebore.8a35b6c7.jpg";